export default __webpack_public_path__ + "static/media/image36.09de05d3.png";